<template>
    <div class="table2_xyscroll sticky" style="height: 500px; background-color: #f9f9f9">
        <table class="table2_default" style="background-color: white;">
            <thead>
                <tr>
                    <th width="120px">{{ $t('popup_reservation_history.label_name') }}</th>
                    <th width="110px">{{ $t('popup_reservation_history.label_group') }}</th>
                    <th width="100px">{{ $t('popup_reservation_history.label_staff') }}</th>
                    <th width="125px">{{ $t('popup_reservation_history.label_appointment_date') }}</th>
                    <th width="120px">{{ $t('popup_reservation_history.label_program') }}</th>
                    <th width="60px">{{ $t('popup_reservation_history.label_action_status') }}</th>
                    <th width="80px">{{ $t('popup_reservation_history.label_modifier') }}</th>
                    <th width="125px">{{ $t('popup_reservation_history.label_received_canceled_date') }}</th>
                </tr>
            </thead>
            <tr v-if="isNoResult">
                <td colspan="8">
                    <div class="no_cont txt_center">{{ $t('popup_reservation_history.label_no_result') }}</div>
                </td>
            </tr>

            <Item
                v-for="(r, index) in results" :key="index"
                :history="r"
            />
        </table>
    </div>
</template>


<script>
import Item from './ReservationHistoryTableItem.vue'

export default {
    components: { Item },
    props: {
        results: Array
    },
    computed: {
        isNoResult: function() { return this.results.length == 0 }
    },
}
</script>